import merge from 'lodash/merge';
import { StyleSheet } from 'react-native';
import { chartConfig } from '../../constants';
var getLegendPosition = legendPosition => {
  if (legendPosition === 'top') return 'column-reverse';
  if (legendPosition === 'left') return 'row-reverse';
  if (legendPosition === 'right') return 'row';else return 'column';
};
export var getChartStyles = props => {
  var canvasWidth = props.canvasWidth,
    canvasHeight = props.canvasHeight,
    _props$legendPosition = props.legendPosition,
    legendPosition = _props$legendPosition === void 0 ? 'top' : _props$legendPosition,
    _props$type = props.type,
    type = _props$type === void 0 ? 'line' : _props$type;
  var doughnutType = type === 'doughnut';
  return StyleSheet.create({
    container: {
      alignItems: 'center',
      flexDirection: getLegendPosition(legendPosition)
    },
    wrapperStyle: Object.assign({
      width: canvasWidth,
      height: canvasHeight
    }, !doughnutType && {
      flexDirection: getLegendPosition(legendPosition)
    }),
    chartStyle: {
      height: '90%',
      width: '90%'
    },
    centerTextStyle: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: [{
        translateX: -50
      }, {
        translateY: -20
      }]
    }
  });
};
export var getChartProps = (props, context) => {
  var _a;
  var theme = (props === null || props === void 0 ? void 0 : props.theme) || (context === null || context === void 0 ? void 0 : context.theme);
  var configProps = merge(chartConfig === null || chartConfig === void 0 ? void 0 : chartConfig[theme], (_a = context === null || context === void 0 ? void 0 : context.chart) === null || _a === void 0 ? void 0 : _a[theme]);
  return Object.assign(Object.assign({
    theme
  }, configProps), props);
};